export enum TagPrefix {
    EXTERNAL = 'ext',
    INTERNAL = 'vc',
    PRIVATE = 'pvt',
}
